export default __webpack_public_path__ + "static/media/guest_17_01.2bfcd50b.png";